import { useContext } from 'react';
import { context } from '../../context';

export const useHandlePaginate = () => {
  const { dispatch, data, queryParam, dispatchMetrics } = useContext(context);

  const handlePaginate = async () => {
    const offset = queryParam.offset + queryParam.limit;

    dispatchMetrics('event:track', {
      category: 'avaliacao-pdp',
      action: 'ver-mais-avaliacoes',
    });

    dispatch({ type: 'SET_OFFSET', data: offset });
    dispatch({ type: 'SET_FETCH_MORE_LOADING', data: true });

    const response = await data?.fetchMore({
      variables: {
        ...queryParam,
        offset,
      },
    });

    dispatch({
      type: 'SET_DATA',
      data: {
        reviews: [...data.reviews, ...response.data.reviews.result],
        total: response?.data?.reviews?.meta?.total,
        comments: response?.data?.reviews?.meta?.total,
      },
    });
    dispatch({ type: 'SET_FETCH_MORE_LOADING', data: false });
  };

  return { handlePaginate };
};

export default useHandlePaginate;
